class MassDrawer extends HTMLElement {
  constructor(){
    super();
    this.drawer = this.querySelector("#mass-drawer");
    this.wrapper = this.querySelector(".massdrawer__wrapper");
    this.header = this.querySelector(".massdrawer__header");
    this.body = this.querySelector(".massdrawer__body");
    this.footer = this.querySelector(".massdrawer__footer");
    this.cartFooter = this.querySelector("cart-footer");
    this.heart = document.getElementById("heart-button");
    this.closeButton = this.querySelector("#mass-cart_icon-close");

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.closeButton.addEventListener('click', this.close.bind(this));

    this.suggestions = this.querySelector(".mass-drawer__suggestions");
    this.suggestions.closeButton = this.suggestions.querySelector("#mass-cart__suggestions_icon-close");
    this.suggestions.header = this.suggestions.querySelector(".mass-drawer__suggestions-header ");
    this.suggestions.productGrid = this.suggestions.querySelector(".product-grid");

    this.recommendations = {};
    this.items = {};

    this.quickFooter = this.querySelector(".mass-drawer__quick-footer");

    // this.progress = this.querySelector(".mass-drawer__progress");
    // this.cartTotal = this.ldBar.getAttribute("cart-total");
    // alert((parseInt(this.cartTotal)/70*100));
  }
  connectedCallback(){
    this.recommendationsShrink();
    this.resetIds();
    this.renderCompleted();
  }

  renderCompleted() {
    this.createProgress();
    this.initSwiper();
    initKlaviyo();
    this.suggestions.querySelector("product-recommendations") ? this.suggestions.style.display = "block" : this.suggestions.style.display = "none";
    // this.cartFooter.toggleStickyCheckout();
    this.setSuggestionsBottom();
  }

  resetIds() {
    this.recommendations.ids = [];
    this.items.ids = [];
    this.querySelectorAll(".cart-item").forEach(element => this.items.ids.push(element.dataset.productid));
  }
  initSwiper() {
    new Swiper(this.querySelector(".swiper"), {
      speed: 400,
      spaceBetween: 100,
      // createElements: true, //creates arrows
      navigation: true,
      observer: true,
      // loop: true,
      rewind: true,
      autoheight: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      // effect: 'cube',
      // cubeEffect: {
      //   slideShadows: false,
      // },
      // effect: 'flip',
      // flipEffect: {
      //   slideShadows: false,
      // },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      mousewheel: true,
      autoplay: {
        delay: 2000,
        // disableOnInteraction: false,
        // pauseOnMouseEnter: true
      },
    });
  }
  recommendationsShrink() {
    this.suggestions.header.addEventListener("click", () => {
      this.suggestions.classList.contains("shrunk") ? this.suggestions.classList.remove("shrunk") : this.suggestions.classList.add("shrunk");
      this.setSuggestionsBottom();
    });
  }
  recommendationsUnshrink() {} 

  createProgress() {
    var progressBar = this.querySelector(".mass-drawer__custom-ld-bar");
    new ldBar(progressBar, {
      'value': (parseInt(progressBar.dataset.cartTotal) / progressBar.dataset.freeShippingThreshold * 100),
      'style': "width:100%;height:60px",
      'stroke-width': "20",
      'type': "fill",
      'fill-dir': "ltr",
      'img': "https://cdn.shopify.com/s/files/1/0596/0741/7009/files/logo-blue-svg.svg"
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    document.body.addEventListener('click', this.onBodyClick);
    this.querySelectorAll('flickity-large').forEach(flickityLarge => flickityLarge.flickity.resize());
    // this.resizeButton = this.querySelector()
    this.setSuggestionsBottom();
    this.cartFooter.toggleStickyCheckout();

  }
  setSuggestionsBottom() {
    this.quickFooter = this.querySelector(".mass-drawer__quick-footer");
    this.suggestions.style.bottom = this.quickFooter.offsetHeight + "px";
  }
  close() {
    this.drawer.classList.remove('is-open');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('mass-drawer') && !target.closest("#heart-button") && !target.closest("[class*='mfp']")) {
      this.close();
    }
  }
}

customElements.define("mass-drawer", MassDrawer);